import Typography from '@alltrails/shared/denali/components/Typography';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Link from '@alltrails/shared/denali/components/Link';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import useMobileWidth from 'hooks/useMobileWidth';
import Button from '@alltrails/shared/denali/components/Button';
import LinkedInIcon from '@alltrails/shared/components/socialIcons/LinkedInIcon';
import FacebookIcon from '@alltrails/shared/components/socialIcons/FacebookIcon';
import InstagramIcon from '@alltrails/shared/components/socialIcons/InstagramIcon';
import TikTokIcon from '@alltrails/shared/components/socialIcons/TikTokIcon';
import TwitterIcon from '@alltrails/shared/components/socialIcons/TwitterIcon';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import * as styles from './ContactUs.module.scss';

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A10751&t=ek28S5j6RKi1yX4H-1
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A11274&t=ek28S5j6RKi1yX4H-1

const br = () => <br />;

export default function ContactUs() {
  const isMobile = useMobileWidth();
  const languageRegionCode = useLanguageRegionCode();
  const imageFileName = `https://cdn-assets.alltrails.com/press/contact_us/PR-KIT-IMG-${languageRegionCode}${isMobile ? '-M' : '-D'}`;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.left}>
          <Typography component="div" variant="heading600" className={styles.header}>
            <FormattedMessage defaultMessage="Contact us" />
          </Typography>

          <div className={styles.info}>
            <div className={styles.pressContact}>
              <Typography className={styles.press} component="div" variant="heading400">
                <FormattedMessage defaultMessage="Press contact" />
              </Typography>
              <Typography component="div" variant="paragraph200">
                <p>
                  Meaghan Praznik <br /> {languageRegionCode !== LanguageRegionCode.English && '+1'} (628) 283-7484
                </p>
              </Typography>
              <Link className={styles.email} href="mailto:press@alltrails.com">
                <FormattedMessage defaultMessage="Email me" />
              </Link>
            </div>
            <div>
              <Typography component="div" variant="heading400">
                <FormattedMessage defaultMessage="Address" />
              </Typography>
              <Typography component="div" variant="paragraph200">
                <p>
                  530 Bush Street, 9th Floor <br /> San Francisco, CA, 94108
                </p>
                <div className={styles.links}>
                  <LinkedInIcon openInNewTab />
                  <FacebookIcon openInNewTab />
                  <InstagramIcon openInNewTab />
                  <TikTokIcon openInNewTab />
                  <TwitterIcon openInNewTab />
                </div>
              </Typography>
            </div>
          </div>
        </div>
        <div className={styles.download}>
          <picture>
            <source srcSet={`${imageFileName}.avif`} type="image/avif" />
            <source srcSet={`${imageFileName}.webp`} type="image/webp" />
            <img className={styles.img} loading="lazy" src={`${imageFileName}.jpg`} alt="" />
          </picture>
          <div className={styles.presskit}>
            <Typography component="div" variant="heading600" className={styles.presstext}>
              <FormattedMessage defaultMessage="Download <br></br> our press kit" values={{ br }} />
            </Typography>
            <Button
              linkInfo={{
                href: 'https://drive.google.com/drive/folders/1QTjGj2fcGS4CNTl0DAdS0W3wY7qqUH_n?usp=share_link'
              }}
              testId="view-assets"
              text={<FormattedMessage defaultMessage="View assets" />}
              variant="elevated"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
